(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["events-contact"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ceremony-inquiry-form__form').forEach((form) => {
    if (form.dataset.leadScoreInit) return;
    form.dataset.leadScoreInit = 'true';

    const scoreField = form.querySelector('[data-lead-score-field]');
    const categoryField = form.querySelector('[data-lead-category-field]');
    const dateField = form.querySelector('[data-lead-score-date]');
    const selectFields = form.querySelectorAll('[data-lead-score-select]');
    const budgetField = form.querySelector('[data-lead-score-budget]');

    const dateUrgencyScore = () => {
      if (!dateField || !dateField.value) return 0;
      const eventDate = new Date(dateField.value);
      const diffDays = (eventDate - new Date()) / (1000 * 60 * 60 * 24);
      if (diffDays < 0) return 0;
      if (diffDays <= 90) return 3;
      if (diffDays <= 180) return 2;
      if (diffDays <= 365) return 1;
      return 0;
    };

    const budgetScore = () => {
      if (!budgetField || !budgetField.value.trim()) return 0;

      const numeric = Number(budgetField.value.replace(/[^0-9]/g, ''));
      if (!numeric) return 0;
      if (numeric < 50000) return 1;
      if (numeric < 100000) return 2;
      if (numeric < 250000) return 3;
      if (numeric < 500000) return 4;
      return 5;
    };

    const updateScore = () => {
      let total = dateUrgencyScore() + budgetScore();

      selectFields.forEach((select) => {
        const option = select.options[select.selectedIndex];
        total += option ? Number(option.dataset.score || 0) : 0;
      });

      let category = 'Soğuk';
      if (total >= 9) {
        category = 'Sıcak';
      } else if (total >= 5) {
        category = 'Ilık';
      }

      if (scoreField) scoreField.value = total;
      if (categoryField) categoryField.value = category;
    };

    selectFields.forEach((select) => select.addEventListener('change', updateScore));
    if (dateField) dateField.addEventListener('change', updateScore);
    if (budgetField) budgetField.addEventListener('input', updateScore);

    updateScore();
  });

  // Fire Meta Pixel Lead event when the form has just been submitted successfully.
  // Shopify's native contact form reloads the page on success, and this success
  // banner only renders when form.posted_successfully? is true for this form
  // instance — so its presence in the DOM is a reliable one-time signal.
  if (document.querySelector('.ceremony-inquiry-form__success')) {
    if (typeof fbq === 'function') {
      fbq('track', 'Lead', {
        content_name: 'Etkinlik Talebi'
      });
    }
  }
  } catch(e) { console.error(e); }
})();

})();
